import React, { useState } from "react";
import { motion } from "framer-motion";
import {
  IllusSolar,
  IllusBattery,
  IllusHVAC,
  IllusWater,
  IllusITE,
  IllusRewards,
  IllusTrack,
} from "./Illustrations";
import SolutionDetail from "./SolutionDetail";

const CARDS = [
  { id: "solar", title: "Passer au solaire", body: "Panneaux photovoltaïques haut rendement, étude et pose complète.", Illus: IllusSolar },
  { id: "battery", title: "Ajouter une batterie", body: "Stockage lithium 5–20 kWh pour maximiser votre autoconsommation.", Illus: IllusBattery },
  { id: "hvac", title: "Pompe à chaleur", body: "Air/eau, air/air ou géothermie — installation par frigoriste agréé.", Illus: IllusHVAC },
  { id: "water", title: "Chauffe-eau solaire", body: "Ballon thermodynamique et solaire, économies immédiates.", Illus: IllusWater },
  { id: "ite", title: "Isolation extérieure", body: "ITE polystyrène, laine de roche ou fibre bois — DPE +2 à +3 lettres.", Illus: IllusITE },
  { id: "rewards", title: "Cumuler les aides", body: "MaPrimeRénov', CEE, éco-PTZ — on monte tous vos dossiers.", Illus: IllusRewards },
  { id: "track", title: "Suivre votre production", body: "Application mobile de suivi en temps réel de vos panneaux.", Illus: IllusTrack },
];

export default function SolutionsGrid() {
  const [active, setActive] = useState(null);
  return (
    <section
      id="solutions"
      className="py-20 lg:py-32 bg-[#F5F1EA] border-y border-[#e2d9ce]"
      data-testid="solutions-section"
    >
      <div className="max-w-[1240px] mx-auto px-6 lg:px-10">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 0.8 }}
          className="font-serif-display font-medium text-[36px] sm:text-[52px] lg:text-[68px] leading-[1] tracking-tight text-[#0F172A] max-w-3xl balance"
        >
          Comment pouvons-nous vous <em className="not-italic text-[#E65100]">aider</em> aujourd'hui ?
        </motion.h2>
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.15, duration: 0.6 }}
          className="mt-6 text-[15px] lg:text-[16px] text-[#334155] max-w-xl leading-relaxed"
        >
          Cliquez sur une solution pour découvrir en détail : bénéfices, méthode HMCD, réalisations avant/après et témoignages clients.
        </motion.p>

        <div className="mt-14 lg:mt-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-5">
          {CARDS.slice(0, 4).map((c, i) => renderCard(c, i))}
        </div>
        <div className="mt-4 lg:mt-5 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-5">
          {CARDS.slice(4).map((c, i) => renderCard(c, i))}
        </div>
      </div>

      <SolutionDetail solutionId={active} onClose={() => setActive(null)} />
    </section>
  );

  function renderCard(c, i) {
    const Illus = c.Illus;
    return (
      <motion.button
        key={c.id}
        onClick={() => setActive(c.id)}
        data-testid={`solution-card-${c.id}`}
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.6, delay: (i % 4) * 0.06, ease: [0.22, 1, 0.36, 1] }}
        className="group text-left bg-[#FDFBF7] border border-[#e2d9ce] rounded-2xl overflow-hidden card-tilt hover:border-[#0F172A]"
      >
        <div className="aspect-[4/3] overflow-hidden">
          <Illus className="w-full h-full transition-transform duration-[900ms] group-hover:scale-105" />
        </div>
        <div className="p-5 lg:p-6">
          <h3 className="font-serif-display text-xl lg:text-2xl text-[#0F172A] leading-tight">
            {c.title}
          </h3>
          <p className="mt-2 text-[14px] text-[#334155] leading-relaxed">
            {c.body}
          </p>
          <div className="mt-4 font-mono-tech text-[10px] uppercase tracking-[0.22em] text-[#2D7A4D] flex items-center gap-1.5">
            Voir en détail
            <span className="transition-transform group-hover:translate-x-1">→</span>
          </div>
        </div>
      </motion.button>
    );
  }
}
